import { generateActions } from 'reducers/utils/HttpReducerHelper';

import { fundingEnquiriesList } from './types';

const fundingEnquiriesListHTTPActions = generateActions(fundingEnquiriesList);
export const requestFundingEnquiriesList = fundingEnquiriesListHTTPActions.request;
export const requestFundingEnquiriesListSuccess = fundingEnquiriesListHTTPActions.success;
export const requestFundingEnquiriesListFailure = fundingEnquiriesListHTTPActions.failure;
